const url = "https://beney.com.cn/api/v1/"

const config = {
    url
}

export default config;